import { render, staticRenderFns } from "./TpmAnalyticsDashboard.vue?vue&type=template&id=21f5b393&scoped=true"
import script from "./TpmAnalyticsDashboard.vue?vue&type=script&lang=ts"
export * from "./TpmAnalyticsDashboard.vue?vue&type=script&lang=ts"
import style0 from "./TpmAnalyticsDashboard.vue?vue&type=style&index=0&id=21f5b393&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5b393",
  null
  
)

export default component.exports